import { useEffect, useMemo, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Box, Tab, Tabs } from '@mui/material';
import './App.css';
import { FAVORITES_STORAGE_KEY, TAB } from './constants';
import StockTable from './components/stock-table/StockTable';
import { CustomTabPanel } from './components/custom-tab-panel/CustomTabPanel';
import { a11yProps } from './components/custom-tab-panel/utils/a11yProps';
import { Backup } from './components/backup/Backup';
import { BackupRestore } from './components/backup/BackupRestore';
import { useRestoreBackupFromUrl } from './components/backup/hooks/useRestoreBackupFromUrl';

const ONE_HOUR = 1000 * 60 * 60;

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: ONE_HOUR,
      },
    },
  });

  useRestoreBackupFromUrl();

  const [tab, setTab] = useState<number>(TAB.companies);

  // "[]" tem 2 caracteres: acima disso já existe pelo menos um ativo salvo.
  const hasFavorite = useMemo(() => (localStorage.getItem(FAVORITES_STORAGE_KEY)?.length ?? 0) > 2, []);

  // Quem já tem carteira abre direto na aba Carteira.
  useEffect(() => {
    if (hasFavorite) setTab(TAB.wallet);
  }, [hasFavorite]);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App" style={{ padding: 0 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: null }} padding={0}>
          <Tabs value={tab} onChange={(_, newTab: number) => setTab(newTab)} aria-label="dividendos">
            <Tab label="Empresas" {...a11yProps(TAB.companies)} />
            <Tab label="Carteira" {...a11yProps(TAB.wallet)} />
            <Tab label="Backup" {...a11yProps(TAB.backup)} />
          </Tabs>
          <CustomTabPanel value={tab} index={TAB.companies}>
            <StockTable />
          </CustomTabPanel>
          <CustomTabPanel value={tab} index={TAB.wallet}>
            <StockTable walletOnly />
          </CustomTabPanel>
          <CustomTabPanel value={tab} index={TAB.backup}>
            <Backup changeToRestoreBackup={() => setTab(TAB.backupRestore)} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} index={TAB.backupRestore}>
            <BackupRestore />
          </CustomTabPanel>
        </Box>
      </div>
    </QueryClientProvider>
  );
}

export default App;
